import React, { Component } from 'react';
import Uppy from '@uppy/core';
import AwsS3 from '@uppy/aws-s3';
import {
  FileUpload,
  Label,
  InputGroup,
  File,
} from 'prospect-path-components';
import axios from 'axios';
import ms from 'ms';
import PropTypes from 'prop-types';
import ErrorText from './ErrorText';

export default class ScreenshotUpload extends Component {
  constructor(props) {
    super(props);

    this.fileInput = React.createRef();
    this.uploadArea = React.createRef();

    this.deleteUploadUrl = this.deleteUploadUrl.bind(this);
    this.onFileClicked = this.onFileClicked.bind(this);
    this.addFiles = this.addFiles.bind(this);
    this.uploadLogo = this.uploadLogo.bind(this);
    this.handleDragIn = this.handleDragIn.bind(this);
    this.handleDragOut = this.handleDragOut.bind(this);
    this.handleDrag = this.handleDrag.bind(this);
    this.handleDrop = this.handleDrop.bind(this);

    this.fileUploader = Uppy({
      autoProceed: true,
      restrictions: {
        allowedFileTypes: ['image/*'],
      },
    });

    this.fileUploader.on('upload-success', (file, response) => {
      const { screenshots } = this.props;
      const { location } = response.body;

      screenshots.push(location);

      this.props.onChange(screenshots);
    });
  }
  componentDidMount() {
    this.fileUploader.use(AwsS3, {
      limit: 1,
      timeout: ms('1 minute'),
      getUploadParameters: (file) => {
        const { type } = file;
        const uploadType = 'screenshot';

        return axios.post(
          `/api/teams/${this.props.team.id}/products/${this.props.product.id}/uploads`,
          {
            type: uploadType,
            content_type: type,
          },
        )
          .then(response => ({
            method: 'PUT',
            url: response.data.uri,
          }));
      },
    });

    const uploadArea = this.uploadArea.current;
    uploadArea.addEventListener('dragenter', this.handleDragIn);
    uploadArea.addEventListener('dragleave', this.handleDragOut);
    uploadArea.addEventListener('dragover', this.handleDrag);
    uploadArea.addEventListener('drop', this.handleDrop);
  }
  componentWillUnmount() {
    this.fileUploader.close();
    const uploadArea = this.uploadArea.current;

    uploadArea.removeEventListener('dragenter', this.handleDragIn);
    uploadArea.removeEventListener('dragleave', this.handleDragOut);
    uploadArea.removeEventListener('dragover', this.handleDrag);
    uploadArea.removeEventListener('drop', this.handleDrop);
  }
  handleDragIn(e) {
    e.preventDefault();
  }
  handleDragOut(e) {
    e.preventDefault();
  }
  handleDrag(e) {
    e.preventDefault();
  }
  handleDrop(e) {
    e.preventDefault();
    const { files } = e.dataTransfer;

    if (files && files.length > 0) {
      this.addFiles(files);
    }
  }
  deleteUploadUrl(url) {
    const uploadedFile = Object.values(this.fileUploader.state.files).find(file => file.uploadURL === url);
    if (uploadedFile) {
      this.fileUploader.removeFile(uploadedFile.id);
    }

    const uploadUrls = this.props.screenshots.filter(uploadUrl => uploadUrl !== url);

    this.props.onChange(uploadUrls);
  }
  addFiles(files) {
    [...files].forEach(file => this.fileUploader.addFile({
      name: file.name,
      type: file.type,
      data: file,
    }));
  }
  uploadLogo(event) {
    this.addFiles(event.target.files);
  }
  onFileClicked() {
    this.fileInput.current.click();
  }
  errorsForField(field) {
    if (this.props.errors[field]) {
      return this.props.errors[field].map(error => <ErrorText>{error}</ErrorText>);
    }

    return '';
  }
  render() {
    return (
      <InputGroup>
        <input
          ref={this.fileInput}
          type="file"
          accept="image/*"
          onChange={this.uploadLogo}
          style={{ display: 'none' }}
        />

        <Label>Screenshots (At least one required, maximum 10)</Label>
        {this.errorsForField('screenshots')}
        <div ref={this.uploadArea}>
          { !this.props.disabled && <FileUpload onFileClicked={this.onFileClicked} /> }
        </div>

        {this.props.screenshots.length > 0 && (
          <div style={{ display: 'block', marginTop: '1rem' }}>
            {this.props.screenshots.map(uploadUrl => (
              <File
                key={uploadUrl}
                onDeleteClicked={() => (this.props.disabled ? () => {} : this.deleteUploadUrl(uploadUrl))}
                src={uploadUrl}
                style={{ marginRight: '1rem', display: 'inline-block' }}
              />
            ))}
          </div>
        )}
      </InputGroup>
    );
  }
}

ScreenshotUpload.defaultProps = {
  errors: {},
  screenshots: [],
  disabled: false,
};

ScreenshotUpload.propTypes = {
  onChange: PropTypes.func.isRequired,
  team: PropTypes.object.isRequired,
  product: PropTypes.object.isRequired,
  errors: PropTypes.object,
  screenshots: PropTypes.array,
  disabled: PropTypes.bool,
};
